import React from 'react';
import { Card, Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { maskFieldInError } from '~/util';

interface DevErrorModalProps {
    error: CustomError;
}
export function DevErrorModal({ error }: DevErrorModalProps) {
    const [show, setShow] = React.useState(true);
    const [detailsCollapsed, setDetailsCollapsed] = React.useState(true);

    function copyToClipboard() {
        if (error.response) {
            navigator.clipboard.writeText(JSON.stringify(error, null, 4));
        } else {
            navigator.clipboard.writeText(error.toString());
        }
    }

    const modalId = `error-title-${new Date().getMilliseconds()}`;
    return (
        <BSModal show={show} onHide={() => setShow(false)} aria-labelledby={modalId}>
            <Modal.Header closeButton>
                <Modal.Title id={modalId} role="heading" aria-level={1}>
                    <i className="fa-solid fa-lg fa-exclamation-triangle text-warning me-2 pt-2 text-truncate" />
                    Sorry, we encountered an error!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Backend/Api errors will have a response & details top-level property */}
                <>
                    <p>{error.response?.status ? error.response?.statusText : error.toString()}</p>

                    <p>
                        {error.response?.status === 400 && (
                            <span>&nbsp;Please correct any problems below and try again.</span>
                        )}
                    </p>

                    <ul className="ms-2">
                        {error.response?.status === 400 &&
                            error.response?.data?.violations &&
                            error.response?.data?.violations.map((violation) => (
                                <li className="text-danger" key={violation.message}>
                                    {violation.message}
                                </li>
                            ))}

                        {error.response?.status === 400 &&
                            !(
                                error.response?.data?.violations &&
                                error.response?.data?.violations.length
                            ) && <li className="text-danger">Problems unknown.</li>}
                    </ul>

                    <p>
                        <span>
                            If this problem persists, email{' '}
                            <a href="mailto:HelpDesk@wellmed.net">HelpDesk@wellmed.net</a>{' '}
                        </span>
                        <span>
                            and provide a screenshot or copy of the text included in the &quot;Show
                            Details&quot; area below.
                        </span>
                    </p>
                </>

                <Card>
                    <Card.Header>
                        <button
                            className="link-button"
                            type="button"
                            onClick={() => setDetailsCollapsed((prev) => !prev)}
                        >
                            <i
                                className={`fa-solid me-1 ${
                                    detailsCollapsed ? 'fa-caret-right' : 'fa-caret-down'
                                }`}
                            />
                            {detailsCollapsed ? 'Show' : 'Hide'} Details
                        </button>
                        <button
                            type="button"
                            onClick={copyToClipboard}
                            className="float-end link-button"
                        >
                            Copy to Clipboard
                        </button>
                    </Card.Header>
                    {!detailsCollapsed && (
                        <Card.Body>
                            <pre style={{ wordWrap: 'normal' }}>
                                {error.details
                                    ? maskFieldInError('_password', error.details)
                                    : error.toString()}
                            </pre>
                        </Card.Body>
                    )}
                </Card>
            </Modal.Body>
        </BSModal>
    );
}
